<template>
    <div>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 768 570" ref="BubbleAnchorMobile" role="img">
  <defs>
    <style>
      .cls-1 {
        fill: #fff;
      }

      .cls-2 {
        fill: #d52b3b;
      }
    </style>
  </defs>
  <title>New Phase Coming Soon - REGISTER NOW</title>
  <path class="cls-1" d="M725.58,186.93c1.35-15.38,4.79-30.62,3.84-46.05-1.37-22.17-11.84-42-25.12-55.58-35.79-36.59-83.79-50.23-127.44-33.62-24,9.12-46.47,24.06-70.59,32.59-23.36,8.26-46.83,7.4-70.77,5.49C388.2,86,341.86,68.27,299.12,41.45,250.34,10.82,213.21-.91,156,.05,93.63,1.1,42.69,32.12,13.18,107.28,8.43,119.4,4.25,131.54,0,143.52V506.66H768V273.05C746.23,250.49,722,227.26,725.58,186.93Z"/>
  <path class="cls-2" d="M726.94,279.5c-20.55-25.82-51.15-48.38-47.47-93.87,1.18-14.59,4.19-29,3.36-43.69a87.529,87.529,0,0,0-22-52.72C629.59,54.51,587.65,41.57,549.5,57.33c-21,8.65-40.61,22.83-61.69,30.92-20.41,7.83-40.92,7-61.84,5.2-41.34-3.58-81.84-20.38-119.18-45.83-42.64-29-75.08-40.17-125.09-39.26-54.49,1-99,30.42-124.8,101.72-11.83,32.71-19.59,65.68-36.21,94.37C14,216.06,7,227.44,0,238.92V613.2H768V331.48C754.49,311.9,742.66,299.27,726.94,279.5Z"/>
<g id="anchor">
		<path class="st0" d="M216.6,198.6v26.1H206v-45.6h8.2l21.2,26.8v-26.8H246v45.6h-8.5L216.6,198.6z"/>
		<path class="st0" d="M285.5,215.4v9.2h-32v-45.6h31.4v9.2H264v8.9h18v8.5h-18v9.7H285.5z"/>
		<path class="st0" d="M305.8,179.2h9.7l4.6,14.6l4.6-14.6h9.8l-7.6,21.2l4.6,12.3l11.4-33.5h11.5l-18.2,45.6h-8.8l-7.3-17.8
			l-7.2,17.8H304l-18.2-45.6h11.4l11.5,33.5l4.5-12.3L305.8,179.2z"/>
		<path class="st0" d="M368.5,224.7v-45.6H388c2.2,0,4.2,0.4,6,1.3c1.8,0.9,3.4,2.1,4.7,3.5c1.3,1.5,2.3,3.1,3.1,4.9
			c0.7,1.8,1.1,3.7,1.1,5.6c0,2-0.4,3.9-1.1,5.8c-0.7,1.8-1.7,3.5-3,4.9c-1.3,1.5-2.8,2.6-4.6,3.5c-1.8,0.9-3.8,1.3-6,1.3h-9.2v14.7
			H368.5z M379.1,200.8h8.6c1.2,0,2.3-0.5,3.2-1.6c0.9-1.1,1.3-2.6,1.3-4.7c0-1.1-0.1-2-0.4-2.8c-0.3-0.8-0.7-1.4-1.1-1.9
			c-0.5-0.5-1-0.9-1.6-1.1c-0.6-0.2-1.2-0.4-1.8-0.4h-8.2V200.8z"/>
		<path class="st0" d="M446.5,179.1v45.6h-10.5V206h-18.2v18.7h-10.5v-45.6h10.5v17.6h18.2v-17.6H446.5z"/>
		<path class="st0" d="M466.3,179.1h9.5l16.6,45.6h-10.8l-3.5-10.2h-14.2l-3.5,10.2h-10.8L466.3,179.1z M476.4,207.2l-5.3-16.1
			l-5.5,16.1H476.4z"/>
		<path class="st0" d="M522.3,192.5c-0.1-0.2-0.6-0.5-1.3-1c-0.8-0.5-1.7-1-2.9-1.5c-1.2-0.5-2.4-1-3.8-1.3
			c-1.4-0.4-2.7-0.6-4.1-0.6c-3.8,0-5.6,1.3-5.6,3.8c0,0.8,0.2,1.4,0.6,1.9c0.4,0.5,1,1,1.8,1.4c0.8,0.4,1.8,0.8,3,1.1
			c1.2,0.3,2.6,0.7,4.2,1.2c2.2,0.6,4.2,1.3,5.9,2c1.8,0.7,3.2,1.6,4.5,2.6c1.2,1,2.2,2.3,2.8,3.8c0.7,1.5,1,3.3,1,5.4
			c0,2.6-0.5,4.7-1.4,6.5c-1,1.8-2.2,3.2-3.8,4.3c-1.6,1.1-3.4,1.9-5.5,2.4s-4.2,0.7-6.4,0.7c-1.7,0-3.4-0.1-5.1-0.4
			c-1.8-0.3-3.5-0.6-5.1-1.1c-1.7-0.5-3.3-1.1-4.8-1.8c-1.6-0.7-3-1.5-4.3-2.4l4.6-9.2c0.2,0.2,0.7,0.6,1.7,1.2
			c0.9,0.6,2.1,1.2,3.5,1.8c1.4,0.6,2.9,1.1,4.7,1.6c1.7,0.5,3.4,0.7,5.2,0.7c3.7,0,5.6-1.1,5.6-3.4c0-0.9-0.3-1.6-0.8-2.1
			c-0.6-0.6-1.3-1.1-2.3-1.5s-2.1-0.9-3.5-1.3s-2.8-0.8-4.4-1.3c-2.1-0.6-3.9-1.3-5.5-2.1c-1.5-0.7-2.8-1.6-3.8-2.6
			c-1-1-1.8-2.1-2.2-3.4c-0.5-1.3-0.7-2.8-0.7-4.5c0-2.4,0.4-4.5,1.3-6.4c0.9-1.8,2.1-3.4,3.7-4.7c1.5-1.3,3.3-2.2,5.4-2.9
			c2-0.6,4.2-1,6.5-1c1.6,0,3.1,0.2,4.7,0.4c1.5,0.3,3,0.7,4.4,1.2c1.4,0.5,2.7,1,3.9,1.6c1.2,0.6,2.3,1.2,3.4,1.8L522.3,192.5z"/>
		<path class="st0" d="M565.1,215.4v9.2h-32v-45.6h31.4v9.2h-20.9v8.9h18v8.5h-18v9.7H565.1z"/>
		<path class="st0" d="M160.9,264.8c0-2.7,0.5-5.5,1.5-8.2c1-2.7,2.5-5.1,4.5-7.3c2-2.1,4.4-3.9,7.2-5.2c2.8-1.3,6-2,9.6-2
			c4.3,0,8,0.9,11.1,2.8c3.1,1.8,5.5,4.2,7,7.2l-8.1,5.6c-0.5-1.2-1.2-2.2-2-3c-0.8-0.8-1.7-1.4-2.6-1.9c-0.9-0.5-1.9-0.8-2.9-1
			s-1.9-0.3-2.9-0.3c-2,0-3.8,0.4-5.3,1.2c-1.5,0.8-2.7,1.9-3.7,3.1c-1,1.3-1.7,2.7-2.2,4.4c-0.5,1.6-0.7,3.3-0.7,4.9
			c0,1.8,0.3,3.5,0.8,5.2c0.6,1.7,1.4,3.1,2.4,4.4c1,1.3,2.3,2.3,3.8,3c1.5,0.7,3.1,1.1,5,1.1c0.9,0,1.9-0.1,2.9-0.4
			c1-0.2,2-0.6,2.9-1.1c0.9-0.5,1.8-1.1,2.5-1.9c0.8-0.8,1.4-1.8,1.9-2.9l8.6,5.1c-0.7,1.7-1.7,3.2-3,4.5c-1.3,1.3-2.9,2.4-4.7,3.3
			c-1.8,0.9-3.6,1.6-5.6,2.1s-3.9,0.7-5.8,0.7c-3.3,0-6.3-0.7-9.1-2c-2.8-1.3-5.1-3.1-7.1-5.4c-2-2.2-3.5-4.7-4.6-7.6
			C161.5,270.5,160.9,267.7,160.9,264.8z"/>
		<path class="st0" d="M225.9,288.3c-3.4,0-6.5-0.7-9.2-2c-2.8-1.3-5.2-3.1-7.1-5.2c-2-2.2-3.5-4.6-4.6-7.4
			c-1.1-2.8-1.6-5.6-1.6-8.6c0-3,0.6-5.9,1.7-8.7c1.1-2.8,2.7-5.2,4.7-7.3c2-2.1,4.4-3.8,7.2-5.1c2.8-1.3,5.8-1.9,9.1-1.9
			c3.4,0,6.5,0.7,9.2,2c2.8,1.3,5.2,3.1,7.1,5.3c2,2.2,3.5,4.7,4.6,7.4c1.1,2.8,1.6,5.6,1.6,8.5c0,3-0.6,5.9-1.7,8.7
			c-1.1,2.8-2.7,5.2-4.7,7.3c-2,2.1-4.4,3.8-7.2,5.1C232.3,287.7,229.2,288.3,225.9,288.3z M214.1,265.2c0,1.8,0.3,3.5,0.8,5.1
			c0.5,1.6,1.3,3.1,2.3,4.4c1,1.3,2.3,2.3,3.8,3.1c1.5,0.8,3.2,1.2,5.1,1.2c2,0,3.8-0.4,5.3-1.2c1.5-0.8,2.7-1.9,3.7-3.2
			c1-1.3,1.7-2.8,2.2-4.4c0.5-1.6,0.7-3.3,0.7-5c0-1.8-0.3-3.5-0.8-5.1c-0.5-1.6-1.3-3.1-2.3-4.4c-1-1.3-2.3-2.3-3.8-3
			c-1.5-0.7-3.2-1.1-5.1-1.1c-2,0-3.8,0.4-5.2,1.2c-1.5,0.8-2.7,1.8-3.7,3.1c-1,1.3-1.8,2.7-2.2,4.4
			C214.3,261.8,214.1,263.5,214.1,265.2z"/>
		<path class="st0" d="M289.4,287.9v-27.3l-9.9,19.8h-5.6l-9.9-19.8v27.3h-10.5v-45.6h11.4l11.8,23.8l11.9-23.8h11.4v45.6H289.4z"/>
		<path class="st0" d="M307.4,287.9v-45.6h10.5v45.6H307.4z"/>
		<path class="st0" d="M335.9,261.9v26.1h-10.5v-45.6h8.2l21.2,26.8v-26.8h10.5v45.6h-8.5L335.9,261.9z"/>
		<path class="st0" d="M404.1,283.4c-3.5,3.2-7.5,4.8-12,4.8c-3,0-5.8-0.6-8.5-1.7c-2.7-1.1-5-2.7-7-4.8c-2-2.1-3.6-4.5-4.7-7.4
			c-1.2-2.9-1.7-6.1-1.7-9.5c0-3.1,0.6-6.1,1.7-8.9c1.2-2.8,2.7-5.2,4.8-7.3s4.4-3.7,7.2-4.9c2.8-1.2,5.8-1.8,9-1.8
			c4.2,0,7.9,0.9,11.1,2.7c3.2,1.8,5.5,4.2,7.1,7.3l-7.8,5.9c-1-2.1-2.5-3.6-4.5-4.8c-1.9-1.1-4.1-1.7-6.3-1.7
			c-1.8,0-3.3,0.4-4.8,1.1s-2.7,1.7-3.7,3c-1,1.3-1.8,2.7-2.4,4.4c-0.6,1.7-0.8,3.5-0.8,5.4c0,2,0.3,3.8,0.9,5.5
			c0.6,1.7,1.4,3.1,2.5,4.3s2.3,2.2,3.8,2.9c1.5,0.7,3.1,1,4.9,1c4.1,0,7.8-1.9,11.1-5.7v-1.4h-8.9v-7.6h17.6v23.8h-8.7V283.4z"/>
		<path class="st0" d="M459.5,255.7c-0.1-0.2-0.6-0.5-1.3-1c-0.8-0.5-1.7-1-2.9-1.5c-1.2-0.5-2.4-1-3.8-1.3
			c-1.4-0.4-2.7-0.6-4.1-0.6c-3.8,0-5.6,1.3-5.6,3.8c0,0.8,0.2,1.4,0.6,1.9c0.4,0.5,1,1,1.8,1.4c0.8,0.4,1.8,0.8,3,1.1
			c1.2,0.3,2.6,0.7,4.2,1.2c2.2,0.6,4.2,1.3,5.9,2c1.8,0.7,3.2,1.6,4.5,2.6c1.2,1,2.2,2.3,2.8,3.8c0.7,1.5,1,3.3,1,5.4
			c0,2.6-0.5,4.7-1.4,6.5c-1,1.8-2.2,3.2-3.8,4.3c-1.6,1.1-3.4,1.9-5.5,2.4s-4.2,0.7-6.4,0.7c-1.7,0-3.4-0.1-5.1-0.4
			c-1.8-0.3-3.5-0.6-5.1-1.1c-1.7-0.5-3.3-1.1-4.8-1.8c-1.6-0.7-3-1.5-4.3-2.4l4.6-9.2c0.2,0.2,0.7,0.6,1.7,1.2
			c0.9,0.6,2.1,1.2,3.5,1.8c1.4,0.6,2.9,1.1,4.7,1.6c1.7,0.5,3.4,0.7,5.2,0.7c3.7,0,5.6-1.1,5.6-3.4c0-0.9-0.3-1.6-0.8-2.1
			c-0.6-0.6-1.3-1.1-2.3-1.5s-2.1-0.9-3.5-1.3s-2.8-0.8-4.4-1.3c-2.1-0.6-3.9-1.3-5.5-2.1c-1.5-0.7-2.8-1.6-3.8-2.6
			c-1-1-1.8-2.1-2.2-3.4c-0.5-1.3-0.7-2.8-0.7-4.5c0-2.4,0.4-4.5,1.3-6.4c0.9-1.8,2.1-3.4,3.7-4.7c1.5-1.3,3.3-2.2,5.4-2.9
			c2-0.6,4.2-1,6.5-1c1.6,0,3.1,0.2,4.7,0.4c1.5,0.3,3,0.7,4.4,1.2c1.4,0.5,2.7,1,3.9,1.6c1.2,0.6,2.3,1.2,3.4,1.8L459.5,255.7z"/>
		<path class="st0" d="M490.3,288.3c-3.4,0-6.5-0.7-9.2-2c-2.8-1.3-5.2-3.1-7.1-5.2c-2-2.2-3.5-4.6-4.6-7.4
			c-1.1-2.8-1.6-5.6-1.6-8.6c0-3,0.6-5.9,1.7-8.7c1.1-2.8,2.7-5.2,4.7-7.3c2-2.1,4.4-3.8,7.2-5.1c2.8-1.3,5.8-1.9,9.1-1.9
			c3.4,0,6.5,0.7,9.2,2c2.8,1.3,5.2,3.1,7.1,5.3s3.5,4.7,4.6,7.4c1.1,2.8,1.6,5.6,1.6,8.5c0,3-0.6,5.9-1.7,8.7
			c-1.1,2.8-2.7,5.2-4.7,7.3c-2,2.1-4.4,3.8-7.2,5.1C496.6,287.7,493.6,288.3,490.3,288.3z M478.4,265.2c0,1.8,0.3,3.5,0.8,5.1
			c0.5,1.6,1.3,3.1,2.3,4.4c1,1.3,2.3,2.3,3.8,3.1c1.5,0.8,3.2,1.2,5.1,1.2c2,0,3.8-0.4,5.3-1.2c1.5-0.8,2.7-1.9,3.7-3.2
			c1-1.3,1.7-2.8,2.2-4.4c0.5-1.6,0.7-3.3,0.7-5c0-1.8-0.3-3.5-0.8-5.1c-0.5-1.6-1.3-3.1-2.3-4.4c-1-1.3-2.3-2.3-3.8-3
			c-1.5-0.7-3.2-1.1-5.1-1.1c-2,0-3.8,0.4-5.2,1.2c-1.5,0.8-2.7,1.8-3.7,3.1c-1,1.3-1.8,2.7-2.2,4.4
			C478.7,261.8,478.4,263.5,478.4,265.2z"/>
		<path class="st0" d="M537.8,288.3c-3.4,0-6.5-0.7-9.2-2c-2.8-1.3-5.2-3.1-7.1-5.2c-2-2.2-3.5-4.6-4.6-7.4
			c-1.1-2.8-1.6-5.6-1.6-8.6c0-3,0.6-5.9,1.7-8.7c1.1-2.8,2.7-5.2,4.7-7.3c2-2.1,4.4-3.8,7.2-5.1c2.8-1.3,5.8-1.9,9.1-1.9
			c3.4,0,6.5,0.7,9.2,2c2.8,1.3,5.2,3.1,7.1,5.3s3.5,4.7,4.6,7.4c1.1,2.8,1.6,5.6,1.6,8.5c0,3-0.6,5.9-1.7,8.7
			c-1.1,2.8-2.7,5.2-4.7,7.3c-2,2.1-4.4,3.8-7.2,5.1C544.1,287.7,541.1,288.3,537.8,288.3z M525.9,265.2c0,1.8,0.3,3.5,0.8,5.1
			c0.5,1.6,1.3,3.1,2.3,4.4c1,1.3,2.3,2.3,3.8,3.1c1.5,0.8,3.2,1.2,5.1,1.2c2,0,3.8-0.4,5.3-1.2c1.5-0.8,2.7-1.9,3.7-3.2
			c1-1.3,1.7-2.8,2.2-4.4c0.5-1.6,0.7-3.3,0.7-5c0-1.8-0.3-3.5-0.8-5.1c-0.5-1.6-1.3-3.1-2.3-4.4c-1-1.3-2.3-2.3-3.8-3
			c-1.5-0.7-3.2-1.1-5.1-1.1c-2,0-3.8,0.4-5.2,1.2c-1.5,0.8-2.7,1.8-3.7,3.1c-1,1.3-1.8,2.7-2.2,4.4
			C526.2,261.8,525.9,263.5,525.9,265.2z"/>
		<path class="st0" d="M575.8,261.9v26.1h-10.5v-45.6h8.2l21.2,26.8v-26.8h10.5v45.6h-8.5L575.8,261.9z"/>
	</g>
	<g>
		<path class="st0" d="M135.3,394.9v-77.3h35.5c3.8,0,7.3,0.8,10.5,2.3c3.2,1.6,5.9,3.6,8.2,6.1s4.1,5.4,5.4,8.6
			c1.3,3.2,2,6.5,2,9.7c0,4.5-1,8.7-2.9,12.6c-2,3.9-4.7,7.1-8.2,9.5l16.3,28.4h-24l-13.6-23.7h-8v23.7H135.3z M156.5,352.7h13.4
			c1.3,0,2.5-0.7,3.6-2.2c1.1-1.5,1.7-3.5,1.7-6.1c0-2.7-0.7-4.7-2-6.2s-2.6-2.1-3.9-2.1h-12.9V352.7z"/>
		<path class="st0" d="M261.7,376.4v18.5h-55.1v-77.3h54.1v18.5h-32.9V347H256v17.2h-28.1v12.2H261.7z"/>
		<path class="st0" d="M320.8,388.5c-5.5,4.6-11.9,7-19.1,7c-5,0-9.8-0.9-14.4-2.7c-4.6-1.8-8.6-4.4-12-7.8
			c-3.4-3.4-6.1-7.6-8.2-12.5c-2-4.9-3-10.6-3-16.9c0-5.4,1-10.5,3-15.2c2-4.7,4.8-8.7,8.4-12.2c3.6-3.4,7.8-6.2,12.6-8.2
			c4.8-2,10-3,15.6-3c3.5,0,6.8,0.4,10,1.1c3.2,0.8,6.2,1.9,8.9,3.4c2.7,1.5,5.2,3.3,7.4,5.3c2.2,2.1,4,4.4,5.3,7L319.6,346
			c-1.5-3-3.8-5.5-6.9-7.4c-3-1.9-6.3-2.8-9.7-2.8c-2.5,0-4.9,0.5-7,1.5c-2.1,1-3.9,2.4-5.4,4.2c-1.5,1.8-2.7,4-3.6,6.5
			s-1.3,5.2-1.3,8.2c0,3,0.4,5.8,1.3,8.3c0.9,2.5,2.1,4.6,3.6,6.4c1.6,1.8,3.4,3.2,5.6,4.1s4.6,1.5,7.3,1.5c6.2,0,11.6-2.5,16.3-7.6
			h-13.4v-15.2h31.8v41.2h-17.5V388.5z"/>
		<path class="st0" d="M346.6,394.9v-77.3h21.2v77.3H346.6z"/>
		<path class="st0" d="M425.8,342.8c-2.2-1.3-4.4-2.5-6.8-3.5c-2-0.9-4.2-1.7-6.6-2.5c-2.4-0.8-4.8-1.1-7.1-1.1
			c-1.9,0-3.4,0.3-4.5,0.9c-1.1,0.6-1.7,1.6-1.7,2.9c0,1,0.3,1.9,1,2.5s1.6,1.3,2.8,1.8c1.2,0.5,2.7,1.1,4.5,1.6
			c1.8,0.5,3.8,1.1,6,1.9c3.6,1.1,6.8,2.3,9.6,3.6c2.9,1.3,5.3,2.9,7.4,4.6c2,1.8,3.6,3.9,4.7,6.5c1.1,2.5,1.6,5.6,1.6,9.3
			c0,4.6-0.9,8.5-2.6,11.7c-1.7,3.2-4,5.7-6.8,7.6c-2.8,1.9-6,3.2-9.5,4.1c-3.5,0.8-7.1,1.3-10.6,1.3c-2.8,0-5.7-0.2-8.7-0.7
			c-3-0.4-5.9-1.1-8.9-1.9c-2.9-0.8-5.8-1.7-8.5-2.8s-5.2-2.3-7.6-3.7l9.1-18.6c2.5,1.6,5.2,3,8,4.2c2.3,1.1,5,2.1,7.9,2.9
			c2.9,0.9,5.9,1.3,9,1.3c2.3,0,3.9-0.3,4.8-0.9c0.9-0.6,1.4-1.4,1.4-2.5c0-1.1-0.5-2-1.4-2.8c-0.9-0.8-2.2-1.4-3.8-2
			c-1.6-0.6-3.4-1.2-5.5-1.7c-2.1-0.6-4.3-1.3-6.6-2.1c-3.4-1.2-6.4-2.4-8.8-3.8c-2.5-1.3-4.5-2.9-6.1-4.6c-1.6-1.7-2.8-3.6-3.5-5.8
			c-0.8-2.2-1.1-4.7-1.1-7.5c0-4.3,0.8-8.1,2.3-11.3c1.6-3.3,3.7-6,6.4-8.2c2.7-2.2,5.8-3.8,9.2-5c3.4-1.1,7.1-1.7,10.9-1.7
			c2.8,0,5.6,0.3,8.3,0.8c2.7,0.5,5.3,1.2,7.8,2.1c2.5,0.8,4.8,1.7,7,2.7c2.2,1,4.1,1.9,5.9,2.8L425.8,342.8z"/>
		<path class="st0" d="M504.2,336.1H482v58.8h-21.2v-58.8h-22.3v-18.5h65.8V336.1z"/>
		<path class="st0" d="M564.8,376.4v18.5h-55.1v-77.3h54.1v18.5H531V347h28.1v17.2H531v12.2H564.8z"/>
		<path class="st0" d="M572.6,394.9v-77.3h35.5c3.8,0,7.3,0.8,10.5,2.3c3.2,1.6,5.9,3.6,8.2,6.1s4.1,5.4,5.4,8.6
			c1.3,3.2,2,6.5,2,9.7c0,4.5-1,8.7-2.9,12.6c-2,3.9-4.7,7.1-8.2,9.5l16.3,28.4h-24l-13.6-23.7h-8v23.7H572.6z M593.8,352.7h13.4
			c1.3,0,2.5-0.7,3.6-2.2c1.1-1.5,1.7-3.5,1.7-6.1c0-2.7-0.7-4.7-2-6.2c-1.3-1.4-2.6-2.1-3.9-2.1h-12.9V352.7z"/>
		<path class="st0" d="M277.3,469.1v38h-21.2v-77.3h16.6l31,39.3v-39.3h21.2v77.3H308L277.3,469.1z"/>
		<path class="st0" d="M370.9,507.7c-5.9,0-11.2-1.1-16-3.4c-4.8-2.2-8.9-5.2-12.3-8.9c-3.4-3.7-6.1-7.9-8-12.6
			c-1.9-4.7-2.8-9.6-2.8-14.6c0-5.1,1-10,2.9-14.7c2-4.7,4.7-8.9,8.2-12.5c3.5-3.6,7.7-6.5,12.5-8.6c4.8-2.1,10.1-3.2,15.8-3.2
			c5.9,0,11.2,1.1,16,3.4c4.8,2.3,8.9,5.2,12.3,8.9c3.4,3.7,6,7.9,7.9,12.6c1.9,4.7,2.8,9.5,2.8,14.5c0,5.1-1,10-2.9,14.6
			c-2,4.7-4.7,8.8-8.2,12.4c-3.5,3.6-7.6,6.5-12.5,8.7C381.9,506.7,376.6,507.7,370.9,507.7z M353.3,468.5c0,2.6,0.4,5.1,1.1,7.6
			c0.7,2.4,1.8,4.6,3.3,6.5c1.5,1.9,3.3,3.4,5.5,4.6c2.2,1.2,4.8,1.7,7.9,1.7c3,0,5.7-0.6,8-1.8c2.2-1.2,4.1-2.8,5.5-4.7
			c1.4-1.9,2.5-4.1,3.2-6.6c0.7-2.5,1-5,1-7.5c0-2.6-0.4-5.1-1.1-7.6c-0.7-2.4-1.8-4.6-3.3-6.4c-1.5-1.9-3.3-3.3-5.6-4.5
			c-2.2-1.1-4.8-1.7-7.8-1.7c-3,0-5.7,0.6-7.9,1.7c-2.2,1.2-4,2.7-5.5,4.6c-1.5,1.9-2.5,4.1-3.2,6.5
			C353.7,463.5,353.3,466,353.3,468.5z"/>
		<path class="st0" d="M438.6,429.8h19.5l6.8,23.9l6.9-23.9h19.5l-12.7,36.9l5.6,16.1l16.7-53h23.1l-30.3,77.3h-17.6l-11-27.7
			L454,507.1h-17.6l-30.3-77.3h23l16.8,53l5.3-16.1L438.6,429.8z"/>
	</g>
</svg>
    <!-- <b-container fluid class="background--red" style="margin-top: -3px">
          <b-row>
            <b-col md="12" class="bubble-copy">
            </b-col>
          </b-row>
          <b-row class="bubble-row top highlights-mobile">
            <b-col md="3" cols="6">
                <nuxt-link to="/highlight/community-vision/">
                    <b-img src="/img/icons/community-vision.png" fluid center alt="New Seaton | Community Built From The Ground Up | Community Vision" />
                    <p>community vision</p>
                </nuxt-link>
            </b-col>
            <b-col md="3" cols="6">
                <nuxt-link to="/highlight/new-schools/">
                    <b-img src="/img/icons/new-schools.png" fluid center alt="New Seaton | Community Built From The Ground Up | New Schools" />
                    <p>new schools</p>
                </nuxt-link>
            </b-col>
            <b-col md="3" cols="6">
                <nuxt-link to="/highlight/new-trails/">
                    <b-img src="/img/icons/new-trails.png" fluid center alt="New Seaton | Community Built From The Ground Up | New Trails" />
                    <p>new trails</p>
                </nuxt-link>
            </b-col>
            <b-col md="3" cols="6">
                <nuxt-link to="/highlight/new-parks/">
                    <b-img src="/img/icons/new-parks.png" fluid center alt="New Seaton | Community Built From The Ground Up | New Parks" />
                    <p>new parks</p>
              </nuxt-link>
            </b-col>
          </b-row>
          <b-row class="bubble-row bottom">
            <b-col md="3" cols="6">
                <nuxt-link to="/highlight/new-transit/">
                <b-img src="/img/icons/new-transit.png" fluid center alt="New Seaton | Community Built From The Ground Up | New Transit" />
                <p>new transit</p>
              </nuxt-link>
            </b-col>
            <b-col md="3" cols="6">
                <nuxt-link to="/highlight/new-retail-shops/">
                    <b-img src="/img/icons/new-retailshops.png" fluid center alt="New Seaton | Community Built From The Ground Up | New Retail Shops" />
                    <p>new retail shops</p>
                </nuxt-link>
            </b-col>
            <b-col md="3" cols="6">
                <nuxt-link to="/highlight/new-home-types/">
                    <b-img src="/img/icons/new-hometypes.png" fluid center alt="New Seaton | Community Built From The Ground Up | New Home Types" />
                    <p>new home types</p>
                </nuxt-link>
            </b-col>
            <b-col md="3" cols="6">
                <nuxt-link to="/highlight/award-winning-builders/">
                    <b-img src="/img/icons/award-winningbuilders.png" fluid center alt="New Seaton | Community Built From The Ground Up | Award Winning Builders" />
                    <p>award winning builders</p>
                </nuxt-link>
            </b-col>
          </b-row>

        </b-container> -->
        
<!-- <svg style="margin-top: -16px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 768 362.11"><defs><style>.cls-4{fill:#d52b3b;}</style></defs><title>bubble-bottompart</title><path class="cls-4" d="M41.06,90.26c20.55,25.83,51.15,48.39,47.47,93.88-1.18,14.59-4.19,29-3.36,43.68a87.54,87.54,0,0,0,22,52.73c31.28,34.7,73.22,47.64,111.37,31.89,20.95-8.66,40.61-22.83,61.69-30.92,20.41-7.84,40.92-7,61.84-5.21,41.34,3.59,81.84,20.39,119.18,45.83,42.64,29.05,75.08,40.18,125.09,39.27,54.49-1,99-30.42,124.8-101.72C722.93,227,730.69,194,747.31,165.31c6.72-11.6,13.74-23,20.69-34.46L768-1.09,0-.65,0,38.29C13.51,57.87,25.34,70.5,41.06,90.26Z"/></svg> -->

       
    </div>
</template>

<script>
    export default {
        methods:{
            gotoHighlights() {
                $("html, body").animate({
                scrollTop: $('.highlights-mobile').offset().top-35
                }, 500);
            }
        }
    }
</script>

<style scoped>
#arrow-mobile{
    display: none;
	animation: bounce 1s infinite alternate;
	cursor: pointer;
}

@keyframes bounce{
	0% {
    transform: translateY(0px);
	}
	100% {
		transform: translateY(-15px);
	}
}
</style>

